var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { HttpParams } from '@angular/common/http';
import { CustomFilterService } from 'path-shared/services/datasource/custom-filter-service';
var defaultSortParam = 'EXP';
var defaultSortDirection = 'asc';
var AlegacionesFilterService = /** @class */ (function (_super) {
    __extends(AlegacionesFilterService, _super);
    function AlegacionesFilterService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AlegacionesFilterService.prototype.createFilterParams = function (filter, start, pageSize, sortField, sortDir) {
        return new HttpParams()
            .append('EXP', filter.EXP ? filter.EXP : '')
            .append('NUMDENUNCIA', filter.NUMDENUNCIA ? filter.NUMDENUNCIA : '')
            .append('INFRACCIO', filter.INFRACCIO ? filter.INFRACCIO : '')
            .append('DATAPLEC', filter.DATAPLEC == undefined ? '' : typeof (filter.DATAPLEC) === 'string' ?
            filter.DATAPLEC : filter.DATAPLEC.toDateString())
            .append('AGENTE', filter.AGENTE ? filter.AGENTE : '')
            .append('TIPO', filter.TIPO ? filter.TIPO : '')
            .append('codUser', filter.codUser ? filter.codUser.toString() : '-1')
            .append('start', start.toString())
            .append('size', pageSize.toString())
            .append('sortparam', sortField === undefined ? defaultSortParam : sortField)
            .append('sortdir', sortDir === '' ? defaultSortDirection : sortDir);
    };
    return AlegacionesFilterService;
}(CustomFilterService));
export { AlegacionesFilterService };
